const getPersonId = (pedigree, ids) => {
  if (pedigree?.person?.id) {
    ids.push(pedigree.person.id)
  }
}

const getParentIds = async (parents, getPersonIdsFunc, ids) => {
  if (parents) {
    if (parents.parent1Pedigree) {
      ids.push(await getPersonIdsFunc(parents.parent1Pedigree, []))
    }
    if (parents.parent2Pedigree) {
      ids.push(await getPersonIdsFunc(parents.parent2Pedigree, []))
    }
  }
}

const getChildrenIds = (pairings, ids) => {
  if (pairings) {
    pairings.forEach(({ childPedigrees, spousePedigree }) => {
      childPedigrees?.forEach((childPedigree) => getPersonId(childPedigree, ids))
      getPersonId(spousePedigree, ids)
    })
  }
}

const getSiblingIds = (siblings, ids) => {
  if (siblings) {
    siblings.forEach((siblingPedigree) => getPersonId(siblingPedigree, ids))
  }
}

export default async function getPersonIds(currentPedigree, ids = []) {
  if (!currentPedigree) {
    return ids.flat()
  }

  await getParentIds(currentPedigree.parents, getPersonIds, ids)
  getChildrenIds(currentPedigree.pairings, ids)
  getSiblingIds(currentPedigree.fullSiblingPedigrees, ids)
  getPersonId(currentPedigree, ids)

  return ids.flat()
}
